export class Helper {

    public static Deserialize(data: string): any {
        return JSON.parse(data, Helper.ReviveDateTime);
    }

    private static ReviveDateTime(key: any, value: any): any {
        // Handle ISO 8601 date strings (e.g., "2025-03-06" or "2025-03-06T12:00:00Z")
        if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}(T\d{2}:\d{2}:\d{2}(\.\d+)?(Z|([-+]\d{2}:\d{2})))?$/.test(value)) {
            return new Date(value);
        }

        return value;
    }

    public static isSameDay(d1: Date, d2: Date): boolean {
        return d1.getFullYear() === d2.getFullYear() &&
            d1.getMonth() === d2.getMonth() &&
            d1.getDate() === d2.getDate();
    }
}